var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vue-app" }, [
    _c("div", { staticClass: "container form-container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-md-4 my-3" }, [
          _c("div", { staticClass: "patient-education-content" }, [
            _c("h2", { class: _vm.post_title_h_style }, [
              _vm._v(_vm._s(_vm.post_title)),
            ]),
            _vm._v(" "),
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.post_description) },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-8 my-3" }, [
          _c("form", { attrs: { id: "patient-education-search-form" } }, [
            _c("div", { staticClass: "form-row mb-3" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h5", { staticClass: "mb-2" }, [
                  _vm._v("Search by Keyword"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.keyword,
                      expression: "form.keyword",
                    },
                  ],
                  ref: "keyword",
                  staticClass: "form-control",
                  attrs: { id: "keyword", type: "text", placeholder: "Search" },
                  domProps: { value: _vm.form.keyword },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "keyword", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c(
                "div",
                { staticClass: "col-12 col-md-6" },
                [
                  _c("h5", { staticClass: "mb-2" }, [
                    _vm._v("Search by Cancer Type"),
                  ]),
                  _vm._v(" "),
                  _c("multiselect", {
                    ref: "search_cancer_type",
                    attrs: {
                      id: "search-cancer-type",
                      options: _vm.cancer_types,
                      multiple: true,
                      placeholder: "Types of Cancer:",
                      "close-on-select": false,
                      "clear-on-select": true,
                      selectLabel: "Press enter or click to select",
                      deselectLabel: "Press enter or click to remove",
                      label: "text",
                      "track-by": "id",
                      maxHeight: _vm.dropdownHeight,
                    },
                    on: {
                      open: _vm.onMultiselectOpen,
                      close: _vm.onMultiselectClose,
                    },
                    model: {
                      value: _vm.form.cancer_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "cancer_type", $$v)
                      },
                      expression: "form.cancer_type",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-md-6" },
                [
                  _c("h5", { staticClass: "mb-2" }, [
                    _vm._v("Search by Topic"),
                  ]),
                  _vm._v(" "),
                  _c("multiselect", {
                    ref: "search_topic",
                    attrs: {
                      id: "search-topic",
                      options: _vm.topics,
                      multiple: true,
                      placeholder: "Topics:",
                      "close-on-select": false,
                      "clear-on-select": true,
                      selectLabel: "Press enter or click to select",
                      deselectLabel: "Press enter or click to remove",
                      label: "text",
                      "track-by": "id",
                      maxHeight: _vm.dropdownHeight,
                    },
                    on: {
                      open: _vm.onMultiselectOpen,
                      close: _vm.onMultiselectClose,
                    },
                    model: {
                      value: _vm.form.topic,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "topic", $$v)
                      },
                      expression: "form.topic",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row mt-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary mr-1",
                  attrs: { type: "submit" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.showCards(true)
                    },
                  },
                },
                [_vm._v("Search")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-dark mr-1",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.resetForm()
                    },
                  },
                },
                [_vm._v("Reset Form")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-primary",
                  attrs: { href: _vm.you_tube_link, target: "_blank" },
                },
                [_vm._v("Subscribe to our YouTube channel")]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid clip-path-ellipse-concave-square",
        attrs: { id: "videos-results-wrap" },
      },
      [
        _c("div", { staticClass: "container vue-search-results py-3" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("h2", { staticClass: "h3" }, [_vm._v("Search Results")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Showing " +
                    _vm._s(_vm.min_count) +
                    " - " +
                    _vm._s(_vm.count) +
                    " of " +
                    _vm._s(_vm.total_count) +
                    " results"
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row", attrs: { id: "videos-results" } },
            [
              _vm._l(_vm.patient_education, function (post) {
                return _c("patient-results", {
                  key: post["title"],
                  attrs: { patient_education_video: post },
                })
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12",
                  class: {
                    "d-none":
                      _vm.$store.state.results_count || !_vm.initialized,
                  },
                },
                [_vm._v(_vm._s(_vm.no_results_message))]
              ),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container py-2", class: { "d-none": _vm.has_more } },
          [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.showMoreCards()
                    },
                  },
                },
                [_vm._v("Load More Results")]
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal-wrap",
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.onModalOutsideClick($event)
          },
        },
      },
      [
        _c("div", { staticClass: "youtube-modal p-3" }, [
          _c("div", { staticClass: "modal-body" }),
          _vm._v(" "),
          _c("div", { staticClass: "modal-close-wrap" }, [
            _c(
              "div",
              {
                staticClass: "modal-close btn btn-dark",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.closeModal()
                  },
                },
              },
              [_vm._v("\n                    Close\n                ")]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }